<script lang="ts">
  import type { IconProps } from '@lucide/svelte'
  import type { Component, Snippet } from 'svelte'

  type Props = {
    label: string
    icon: Component<IconProps, Record<string, string>, ''>
    children: Snippet
  }
  let { label, icon: Icon, children }: Props = $props()
</script>

<div class="stat-card-container">
  <div class="icon-container">
    <Icon size="1rem" />
  </div>
  <div class="content-container">
    <h4 class="label">{label}</h4>
    <div class="content">
      {@render children?.()}
    </div>
  </div>
</div>

<style lang="scss">
  .stat-card-container {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    padding: .5rem;
    background: var(--right-bar-input-background);
    border-radius: .25rem;
    flex-direction: row;
    gap: .5rem;
    flex: 1;

    .content-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: .75rem;

      .label {
        font-size: 1rem;
      }

      .content {
        flex: 1;
        display: flex;
        flex-direction: row;
      }
    }
  }
</style>
